import { createAction, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreateUserGroupPayload, LoadUserGroupPayload, ReduxUserGroupAddEditState, UpdateUserGroupPayload, UserGroupFormState } from '../types';
import { ReduxSliceState } from '../../../shared/types';
import { ReduxRootState } from '../../../shared/redux/store';
import { withPayloadType } from '../../../shared/utils';

const initialState: ReduxUserGroupAddEditState = {
    state: 'READY'
};

export const createUserGroup = createAction('userGroups/add-edit/createUserGroup', withPayloadType<CreateUserGroupPayload>());
export const updateUserGroup = createAction('userGroups/add-edit/updateUserGroup', withPayloadType<UpdateUserGroupPayload>());
export const loadUserGroup = createAction('userGroups/add-edit/loadUserGroup', withPayloadType<LoadUserGroupPayload>());


const userGroupsAddEditSlice = createSlice({
    name: 'userGroups/add-edit',
    initialState,
    reducers: {
        setState: (state, action: PayloadAction<ReduxSliceState>) => {
            state.state = action.payload;
        },
        setUserGroup: (state, action: PayloadAction<UserGroupFormState | undefined>) => {
            state.userGroup = action.payload;
        },
    }
});

export default userGroupsAddEditSlice;

const selectSelf = (state: ReduxRootState) => state.userGroupsAddEdit;
export const selectUserGroupsAddEditState = createSelector(selectSelf, self => self.state);
export const selectUserGroupsAddEditStateIsBusy = createSelector(selectUserGroupsAddEditState, state => state === 'BUSY');
export const selectUserGroupsAddEditUserGroup = createSelector(selectSelf, self => self.userGroup);